module.exports = __webpack_public_path__ + "img/6.27b4e38a.jpg";